<template>
  <v-toolbar
    id="core-toolbar"
    text
    flat
  >
    <v-toolbar-items>
      <v-btn
        v-if="responsive"
        text
        icon
        @click.stop="onClickBtn"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-toolbar-title v-if="!$vuetify.breakpoint.xs && !$apollo.loading">
      <p>{{ $t('toolbar.aivBalance') }}:</p>
      <b>{{ me.aiv_balance }}</b>
      <v-btn
        v-if="$route.name != 'Buy AIV'"
        class="btn-buy"
        small
        text
        outlined
        @click="$router.push('/merchants/buy/aiv')"
      >
        {{ $t('toolbar.buyAiv') }}
      </v-btn>
    </v-toolbar-title>

    <v-toolbar-title
      v-if="!$apollo.loading && (!$vuetify.breakpoint.xs || (getUser && getUser.pack != null))"
      :style="!$vuetify.breakpoint.xs ? 'margin-left: 25px':''"
    >
      <p>{{ $t('toolbar.aivRate') }}:</p>
      <b v-if="!$apollo.loading">
        {{ aivRate != undefined ? aivRate.rate.toFixed(6) : '-' }}
        <small
          v-if="aivRate != undefined"
          :class="colorPnL(aivRate.change)"
        >{{ aivRate.change > 0 ? '+' : '' }}{{ aivRate.change }}%</small>
      </b>
      <v-progress-linear
        v-if="aivRate == undefined && $apollo.loading"
        color="red lighten-2"
        buffer-value="0"
        height="18"
        stream
      />
    </v-toolbar-title>
    <helper-loading />

    <v-spacer />
    <v-toolbar-items v-if="me == undefined && !$apollo.loading">
      <v-flex py-3>
        <v-btn
          v-if="!$vuetify.breakpoint.xs"
          text
          @click="$router.push('/login')"
        >
          {{ $t('register.logIn') }}
        </v-btn>
        <v-btn
          class="success"
          @click="signUp()"
        >
          {{ $t('register.signupButton') }}
        </v-btn>
      </v-flex>
    </v-toolbar-items>
    <v-toolbar-items v-if="me != undefined">
      <v-flex
        align-center
        layout
        py-2
      >
        <v-menu
          :nudge-width="270"
          offset-y
          left
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-avatar
              v-if="me.avatar != null"
              style="cursor: pointer; border: 1px solid #f6f8f9"
              :tile="false"
              :size="40"
              v-on="on"
            >
              <v-img
                :src="me.avatar"
                :lazy-src="me.avatar"
                max-height="40"
                contain
              />
            </v-avatar>
            <v-avatar
              v-else
              style="cursor: pointer;"
              :tile="false"
              :size="40"
              color="#f6f8f9"
              v-on="on"
            >
              <strong>
                <a class="text-black">{{ me.name | uppercase | substring(0,2) }}</a>
              </strong>
            </v-avatar>
          </template>

          <v-card class="me-info-card">
            <v-sheet dense>
              <v-list-item class="me-info">
                <v-img
                  v-if="me.avatar != null"
                  :src="me.avatar"
                  :lazy-src="me.avatar"
                  width="100%"
                  max-height="60"
                  contain
                />
                <v-list-item-content>
                  <v-list-item-title>{{ me.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ me.obfuscated_email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider />

              <v-list-item>
                <v-list-item-content>
                  <router-link to="/affiliates">
                    <v-btn
                      outlined
                      small
                      text
                      block
                    >
                      <v-icon left>
                        mdi-star
                      </v-icon>
                      {{ $t('toolbar.referFriends') }}
                    </v-btn>
                  </router-link>
                </v-list-item-content>
              </v-list-item>

              <v-divider v-if="!getTraderMode" />

              <!-- <v-list-item @click.prevent.self="$router.push('/wallets')">
                <v-list-item-icon
                  style="margin-top:14px!important"
                  @click="$router.push('/wallets')"
                >
                  <v-icon>mdi-wallet-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content @click="$router.push('/wallets')">
                  <v-list-item-title>{{ $t('toolbar.myWallets') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="me.staking_wallet == null">
                  <v-btn
                    small
                    class="primary"
                    @click="$router.push('/wallets/verify')"
                  >
                    {{ $t('wallets.addWallet') }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item> -->

              <v-list-item @click="$router.push('/profile')">
                <v-list-item-icon>
                  <v-icon>mdi-account-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.myProfile') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="$router.push('/security')">
                <v-list-item-icon>
                  <v-icon>mdi-shield-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.security') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="$router.push('/subscriptions')">
                <v-list-item-icon>
                  <v-icon>mdi-basket-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.subscriptions') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              
              <v-list-item @click="$router.push('/invoices')">
                <v-list-item-icon>
                  <v-icon>mdi-text-box-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.myInvoices') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="me.unpaid_invoices">
                  <v-icon class="text-danger">
                    mdi-alert-circle
                  </v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-list-item @click="$router.push('/services')">
                <v-list-item-icon>
                  <v-icon>mdi-package-variant-closed</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.myProdcuts') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            

              <v-list-item @click="onEnableLiveChat">
                <v-list-item-icon>
                  <v-icon>mdi-face-agent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.liveChat') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="showChat"
                    color="primary"
                    @click.stop=""
                  />
                </v-list-item-action>
              </v-list-item>
              <v-divider />
              <v-list-item @click="$router.push('/login')">
                <v-list-item-icon>
                  <v-icon>mdi-power</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('toolbar.logOut') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>


import { mapMutations, mapGetters } from "vuex";

import ME_QUERY from "@/graphql/queries/Me.gql";
import AIVRATE_QUERY from "@/graphql/queries/AivRate.gql";
import USER_SETTINGS_QUERY from "@/graphql/queries/UserSettings.gql";

export default {
  data() {
    return {
      title: null,
      responsive: false,
      responsiveInput: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getTraderMode", "getShowChat"]),
    ...mapGetters("user", ["getUser"]),
    showChat: {
      get() {
        return this.getShowChat;
      },
      set(val) {
        this.setShowChat(val)
      }
    }
  },
  watch: {
    showChat(val, oldVal) {
      this.$ls.set('show-chat', val)
      this.$tidioChatApi.display(val)
    },
    $route(val) {
      this.title = val.name;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "user/updateUser" && this.$apollo.queries.me != undefined) {
        this.$apollo.queries.me.refetch();
      }
    });

    const onTidioChatApiReady = () => {
      if (this.$ls.get('show-chat') == undefined) {
        this.showChat = true
      } else {
        this.showChat = this.$ls.get('show-chat')
      }
      window.tidioChatApi.display(this.showChat);
    }
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }
  },
  beforeDestroy() {
    this.$apollo.queries.aivRate.stopPolling();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "setShowChat"]),
    ...mapMutations("user", ["setUser", "setUserSettings"]),
    signUp() {
      let sponsor = this.$cookie.get("sp");
      this.$router.push("/register" + (sponsor != null ? "/" + sponsor : ""));
    },
    onEnableLiveChat() {
      this.showChat = !this.showChat
    },
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1367) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
  },
  apollo: {
    me: {
      query: ME_QUERY,
      fetchPolicy: "network",
      skip() {
        return localStorage.getItem("auth-token") == null;
      },
      result(data) {
        if (!data.loading) {
          this.setUser(this.me);
          this.$i18n.locale = this.me.language;
          localStorage.setItem("language", this.$i18n.locale);
          document.tidioChatLang = this.$i18n.locale;
          setTimeout(()=> {
            this.$tidioChatApi.setVisitorData({
            name: this.getUser.name,
            email: this.getUser.email,
          });
          }, 2000)
        }
      }
    },
    aivRate: {
      query: AIVRATE_QUERY,
      fetchPolicy: "network-only",
      pollInterval: 30 * 1000
    },
    userSettings: {
      query: USER_SETTINGS_QUERY,
      fetchPolicy: "network-only",
      pollInterval: 60 * 1000,
      result({ loading, data: { userSettings } }) {
        if (!loading) {
          this.setUserSettings(userSettings)
        }
      }
    }
  }
};
</script>

<style lang="scss">
#core-toolbar {
  .btn-buy {
    height: 19px;
    margin-left: 5px;
    margin-top: -2px;
  }
  .v-toolbar__title {
    font-size: 0.9rem;
    line-height: 17px;
    margin-top: 4px;
    p {
      margin: 0;
      font-size: 12px;
    }
  }
  background: #fff !important;
  a {
    text-decoration: none;
  }
}
.me-info-card {
  padding: 2px !important;
  .v-list {
    padding: 0;
  }
  .v-list-item__title {
    font-weight: 500;
    font-size: 0.9rem;
  }
  // .me-info {
  //   background-image: linear-gradient(166deg, #0a25a1, #0045be);color:#fff;
  //   .v-list-item__avatar {
  //     color: "#f6f8f9";
  //   }
  //   .v-list-item__title,
  //   .v-list-item__subtitle {
  //     color: #fff!important;
  //   }
  // }
}
</style>
